import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
import {
    initializeFolderViewStates,
    type INITIALIZE_FOLDER_VIEW_STATESActionMessage,
} from 'owa-folders';
import createDragViewState from 'owa-dnd/lib/utils/createDragViewState';
import createDropViewState from 'owa-dnd/lib/utils/createDropViewState';
import type { SortBy } from 'owa-mail-list-store';
import { MailSortHelper } from 'owa-mail-list-store';

export const initializeFolderViewStatesMutator: (
    actionMessage: INITIALIZE_FOLDER_VIEW_STATESActionMessage
) => void = mutator(initializeFolderViewStates, actionMessage => {
    const store = getStore();
    for (const folderId of actionMessage.folderIds) {
        if (!store.folderNodeViewStates.has(folderId)) {
            store.folderNodeViewStates.set(folderId, getDefaultFolderViewState());
        }
    }
});

const getDefaultFolderViewState = () => {
    const defaultSortBy: SortBy = MailSortHelper.getDefaultSortBy();
    return {
        isExpanded: false,
        sortColumn: defaultSortBy.sortColumn,
        sortOrder: defaultSortBy.sortDirection,
        drag: createDragViewState(),
        drop: createDropViewState(),
        color: undefined,
    };
};
